import script from "./WCNotificationStickyAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCNotificationStickyAlert.vue?vue&type=script&setup=true&lang=ts"

import "./WCNotificationStickyAlert.vue?vue&type=style&index=0&id=005e992d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005e992d"]])

export default __exports__